var React = require('react');

function ChevronSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.41421 8.58579L2.87868 5.05025L6.41421 1.51472L5 0.100506L1.46447 3.63604L0.0502526 5.05025L1.46447 6.46447L5 10L6.41421 8.58579Z"}));
}

ChevronSmall.defaultProps = {"width":"7","height":"10","viewBox":"0 0 7 10","fill":"none"};

module.exports = ChevronSmall;

ChevronSmall.default = ChevronSmall;
